import { INFINITE_SCROLL_PAGE_SIZE } from '../../../shared/config/constants'
import type { CollectionFiltersState } from './collectionFilters'

export type CollectionPageContext = {
	cacheKey: string
	limit: number
	offset: number
}

export function buildCollectionCacheKey({
	filters,
	limit = INFINITE_SCROLL_PAGE_SIZE,
	offset = 0,
	searchQuery,
	snapshotId,
}: {
	filters: CollectionFiltersState
	limit?: number
	offset?: number
	searchQuery: string
	snapshotId: string | null
}): string {
	return JSON.stringify({
		favoritesOnly: !!filters.favoritesOnly,
		folderId: filters.folderId ?? null,
		genre: filters.genre,
		limit,
		media: filters.media,
		rating: filters.rating,
		offset,
		search: searchQuery,
		snapshotId,
		sort: filters.sort,
		status: filters.status,
		style: filters.style,
		yearFrom: filters.yearFrom,
		yearTo: filters.yearTo,
	})
}
